export default [
  {
    path: '',
    name: 'user admin list',
    component: () => import('@/views/app/useradmin/list/page-list.vue'),
    meta: { title: 'Daftar Pengguna' },
  },
  {
    path: 'baru',
    name: 'user admin create',
    component: () => import('@/views/app/useradmin/create/page-create.vue'),
    meta: { title: 'Tambah Pengguna' },
  },
  {
    path: 'edit/:id',
    name: 'user admin edit',
    component: () => import('@/views/app/useradmin/edit/page-edit.vue'),
    meta: { title: 'Ubah Pengguna' },
  },
]
